import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=049eb09c&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=049eb09c&lang=scss&scoped=true&"
import style1 from "./Projects.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049eb09c",
  null
  
)

export default component.exports